import * as React from 'react'
import { useEffect, useState } from 'react'
import Box from '@mui/material/Box'
import { DataGrid } from '@mui/x-data-grid'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { showApproveDialog, showDeleteDialog, showHoldDialog, showRejectDialog } from '../../store/slice/dialogSlice'
import { GridToolbar } from '../GridToolbar/GridToolbar'
import DeleteInSaveDialog from '../Dialog/DeleteInSaveDialog'
import { saveAs } from 'file-saver';
import * as XLSX from 'xlsx';
import { Download, Print } from '@mui/icons-material'
import { Button } from '@mui/material'


export default function EditableDataGrid({
  data,
  isLoading,
  columns,
  columnVisibility,
  setColumnVisibility,
  handleUpdateData,
  dynamicKey,
  height,
  showCheckbox,
  handleCellEdit,
  handleAddRow,
  tableDataCore,
  setTableDataCore,
  setDataRowId,
  setDataRow,
  setTableDataSave,
  setAddedRowData,
  size,
  fieldName,
  addRowReqPrivileges,
  hiddenContent,
  showCopyLine,
  copyLine,
  disableSelectionOnClick,
}) {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { pathname } = useLocation()
  const { dataId } = useParams()
  const gridRef = React.useRef()

  // Privileges
  const deletePrivileges = useSelector((state) => state.buttonSlice.deleteData)
  const createPrivileges = useSelector((state) => state.buttonSlice.createData)
  const [selectedCellId, setSelectedCellId] = useState(0)

  //state
  const [tableData, setTableData] = useState(tableDataCore)
  const [pageSize, setPageSize] = React.useState(25)
  const [rowId, setRowId] = useState(0)

  //cell onFocus
  const handleCellClick = (params) => {
    if (params.field === fieldName) setSelectedCellId(params.id)
    else {
      setSelectedCellId(0)
    }
  }

  const handleContainerClick = (event) => {
    if (!event.target.classList.contains('MuiDataGrid-virtualScrollerRenderZone')) {
      setSelectedCellId(0)
    }
  }

  useEffect(() => {
    const gridContainer = gridRef.current
    gridContainer?.addEventListener('click', handleContainerClick)
    return () => {
      gridContainer?.removeEventListener('click', handleContainerClick)
    }
  }, [])

  // Methods
  const handleRowClick = (params) => {
    setDataRow && setDataRow(params?.row)
    setDataRowId && setDataRowId(params?.id)
    setRowId(params?.id)
  }

  const handleDoubleClick = (params) => {
    switch (pathname) {
      case '/users':
        navigate(`/users/${params.row[dynamicKey]}`)
        break
      case '/groups':
        navigate(`/groups/${params.row[dynamicKey]}`)
        break
      case '/requests':
        navigate(`/requests/${params.row[dynamicKey]}`)
        break
      case '/rfqs':
        navigate(`/rfqs/${params.row[dynamicKey]}`)
        break
      case '/approval-stages':
        navigate(`/approval-stages/${params.row[dynamicKey]}`)
        break
      // case `/approval-stages/${dataId}`:
      //   setDataRowId(Number(params.row[dynamicKey]))
      //   break;
      case '/analysis-dimensions':
        navigate(`/analysis-dimensions/${params.row[dynamicKey]}`)
        break
      case '/analysis-codes':
        navigate(`/analysis-codes/${params.row[dynamicKey]}`)
        break
      case '/orders':
        navigate(`/orders/${params.row[dynamicKey]}`)
        break
      case '/bids':
        navigate(`/bids/${params.row[dynamicKey]}`)
        break
      case '/bid-comparison':
        navigate(`/bid-comparison/${params.row[dynamicKey]}`)
        break
      default:
        break
    }
  }

  const handleNavigation = (id) => {
    switch (pathname) {
      case '/users':
        navigate(`/users/${id}`)
        break
      case '/groups':
        navigate(`/groups/${id}`)
        break
      case '/requests':
        navigate(`/requests/${id}`)
        break
      case '/approval-stages':
        navigate(`/approval-stages/${id}`)
        break
      case '/analysis-dimensions':
        navigate(`/analysis-dimensions/${id}`)
        break
      case '/analysis-codes':
        navigate(`/analysis-codes/${id}`)
        break
      case '/orders':
        navigate(`/orders/${id}`)
        break
      case '/bids':
        navigate(`/bids/${id}`)
        break
      case '/bid-comparison':
        navigate(`/bid-comparison/${id}`)
        break
      default:
        break
    }
  }

  const [openDialog, setOpenDialog] = useState(false)

  const handleRowDelete = (id, row) => {
    switch (pathname) {
      case `/approval-stages/${dataId}`:
        setTableDataCore((oldRows) => oldRows?.filter((row) => row.id !== id))

        // Goruntu olaraq datanin silinmesi amma post-da oldugu kimi qalmasi, sadece type: "remove" olmasi ucun yazilib 
        setTableDataSave((oldRows) =>
          oldRows?.map((row) => {
            if (row.id === id) {
              return { ...row, type: 'remove' }
            }
            return row
          })
        )

        setTableData((oldRows) => oldRows?.filter((row) => row.id !== id))

        // Reorder the sequence
        setTableDataCore((oldRows) =>
          oldRows?.map((row, index) => ({
            ...row,
            sequence: index + 1,
          }))
        )

        setTableDataSave((oldRows) =>
          oldRows?.map((row, index) => ({
            ...row,
            sequence: index + 1,
          }))
        )

        // setSelectedList &&
        //   setSelectedList((prevList) => {
        //     return prevList?.filter((ids) => ids !== row.approveRoleId);
        //   });
        break
      case `/approval-roles`:
        if (id <= 0) {
          setOpenDialog(true)
        } else {
          dispatch(showDeleteDialog())
        }
        break
      case `/orders/${dataId}`:
        setTableDataCore((oldRows) => oldRows?.filter((row) => row.lineNo !== id))

        setTableData((oldRows) =>
          oldRows?.map((row) => {
            if (row.lineNo === id) {
              return { ...row, type: 2 }
            }
            return row
          })
        )

        setTableData((oldRows) => oldRows?.filter((row) => row.lineNo !== id))
        break

      case `/invoice-match/${dataId}`:
        setTableDataCore((oldRows) => oldRows?.filter((row) => row.lineNo !== id))

        setTableData((oldRows) =>
          oldRows?.map((row) => {
            if (row.lineNo === id) {
              return { ...row, type: 2 }
            }
            return row
          })
        )

        setTableData((oldRows) => oldRows?.filter((row) => row.lineNo !== id))

        break

      case `/requests/${dataId}`:
        setTableDataCore((oldRows) => oldRows?.filter((row) => row.requestDetailId !== id))

        setTableDataSave((oldRows) =>
          oldRows?.map((row) => {
            if (row.requestDetailId === id) {
              return { ...row, type: 2 }
            }
            return row
          })
        )

        setTableData((oldRows) => oldRows?.filter((row) => row.requestDetailId !== id))
        break
      default:
        dispatch(showDeleteDialog())
        break
    }
  }

  const handleDeleteInSave = () => {
    setAddedRowData((old) => old.filter((row) => row.approveRoleId !== rowId))
    setTableDataCore((old) => old.filter((row) => row.approveRoleId !== rowId))
    setTableData((old) => old.filter((row) => row.approveRoleId !== rowId))
  }

  const handleRowApprove = () => {
    dispatch(showApproveDialog())
  }

  const handleRowReject = () => {
    dispatch(showRejectDialog())
  }

  const handleRowHold = () => {
    dispatch(showHoldDialog())
  }

  const handleReset = () => {
    setTableDataCore(data?.data || data || [])
    setTableData(data?.data || data || tableDataCore || [])
    setTableDataSave && setTableDataSave(data?.data || data || [])
  }

  const gridSize = useSelector((state) => state.dataGridSlice.size)

  useEffect(() => {
    if (!isLoading) {
      setTableData(data?.data || data)
      if (pathname !== '/approval-stages') {
        setSelectedRows((data && data[0]?.id) || (data?.data && data?.data[0]?.id))
        setDataRowId && setDataRowId((data && data[0]?.id) || (data?.data && data?.data[0]?.id))
      }
    }
  }, [data])

  useEffect(() => {
    if (tableDataCore) {
      setTableData(tableDataCore)
    }
  }, [tableDataCore])

  const [selectedRows, setSelectedRows] = useState(
    (pathname !== '/approval-stages' && data && data[0]?.id) || (data?.data && data?.data[0]?.id)
  )

  const exportToExcel = (rows, columns) => {
    const filteredColumns = columns.filter(column => column.field !== 'actions');

    const ws = XLSX.utils.json_to_sheet(
      rows.map(row =>
        filteredColumns.reduce((acc, column) => {
          acc[column.headerName] = row[column.field];
          return acc;
        }, {})
      )
    );

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Data');

    const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    const blob = new Blob([wbout], { type: 'application/octet-stream' });
    saveAs(blob, 'data.xlsx');
  };



  const printTable = (data, columns) => {
    const filteredColumns = columns.filter(column => column.field !== 'actions');

    const printContent = `
      <html>
        <head>
          <title>Print Table</title>
          <style>
            table {
              width: 100%;
              border-collapse: collapse;
            }
            th, td {
              border: 1px solid black;
              padding: 8px;
              text-align: left;
            }
            th {
              background-color: #f2f2f2;
            }
          </style>
        </head>
        <body>
          <table>
            <thead>
              <tr>
                ${filteredColumns.map(column => `<th>${column.headerName}</th>`).join('')}
              </tr>
            </thead>
            <tbody>
              ${data.map(row => `
                <tr>
                  ${filteredColumns.map(column => `<td>${row[column.field]}</td>`).join('')}
                </tr>
              `).join('')}
            </tbody>
          </table>
        </body>
      </html>
    `;

    const printWindow = window.open('', '', 'height=600,width=800');
    printWindow.document.write(printContent);
    printWindow.document.close();
    printWindow.focus();
    printWindow.print();
    printWindow.close();
  };

  return (
    <Box sx={{ height: height, width: '100%' }}>
      <DataGrid
        rows={tableData || []}
        ref={gridRef}
        columns={columns(
          handleNavigation,
          handleRowDelete,
          handleRowApprove,
          handleRowHold,
          handleRowReject,
          deletePrivileges
        )}
        showCellRightBorder
        getCellClassName={(params) => {
          if (params.field === fieldName) {
            return selectedCellId === params.id ? 'MuiDataGrid-cell--editing' : ''
          } else {
            // setSelectedCellId(0);
            return ''
          }
        }}
        onRowDoubleClick={handleDoubleClick}
        onCellClick={handleCellClick}
        onRowClick={(params) => handleRowClick(params)}
        selectionModel={selectedRows}
        onSelectionModelChange={(newSelection) => {
          setSelectedRows(newSelection[0])
          handleUpdateData &&
            handleUpdateData(tableData && tableData.filter((row) => newSelection.includes(row[dynamicKey])))
        }}
        onCellEditCommit={handleCellEdit}
        components={{
          Toolbar: () => (
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <Box sx={{ marginTop: 0.5, marginLeft: 0.5 }}>
                <Button startIcon={<Download />} onClick={() => exportToExcel(tableData, columns())} size="small">
                  Export
                </Button>
                <Button startIcon={<Print />} onClick={() => printTable(tableData, columns())} size="small" >
                  Print
                </Button>
              </Box>
              <GridToolbar
                showCopyLine={showCopyLine}
                handleReset={handleReset}
                handleAddRow={handleAddRow}
                createPrivileges={createPrivileges}
                addRowReqPrivileges={addRowReqPrivileges}
                size={size}
                hiddenContent={hiddenContent}
                copyLine={copyLine}
                hiddenExport={true}
              />
            </Box>
          ),
        }}
        localeText={{ toolbarColumns: 'Columns' }}
        density={gridSize}
        loading={isLoading}
        columnVisibilityModel={columnVisibility}
        onColumnVisibilityModelChange={(newModel) => setColumnVisibility(newModel)}
        getRowId={(row) => row[dynamicKey && dynamicKey]}
        checkboxSelection={showCheckbox}
        disableSelectionOnClick={disableSelectionOnClick}
        pageSize={pageSize}
        onPageSizeChange={(newPage) => setPageSize(newPage)}
        pagination
      />
      <DeleteInSaveDialog open={openDialog} setOpen={setOpenDialog} handleDeleteInSave={handleDeleteInSave} />
    </Box>
  )
}
